import { gql } from '@apollo/client';

export const OFFICE_VALUATION_MUTATION = gql`
  mutation OfficeValuation($input: LeadInput!) {
    lead(input: $input) {
      valuation {
        success
      }
    }
  }
`;
